import {
  Component,
  EventEmitter,
  Input,
  Output,
  ChangeDetectionStrategy,
} from "@angular/core";
import { MatIconModule } from "@angular/material/icon";
import { TranslateModule } from "@ngx-translate/core";

@Component({
  selector: "app-overlay-modal",
  templateUrl: "./overlay-modal.component.html",
  styleUrls: ["./overlay-modal.component.scss"],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatIconModule, TranslateModule],
})
export class OverlayModalComponent {
  @Input() title: string | null = null;
  @Input() mobile = false;

  @Output() backdrop = new EventEmitter<void>();
  @Output() close = new EventEmitter<void>();

  onBackdropClick() {
    this.backdrop.emit();
  }

  onCloseClick(event?: Event) {
    event?.stopPropagation?.();
    this.close.emit();
  }
}
